<template>
    <div>
        <v-row class="px-2 pt-2">
            <!-- Clearing Institute -->
            <v-col md="3" class="py-0">
                <v-select
                    v-model="acquirer"
                    dense 
                    clearable
                    :items="clearingInstituteOptions"
                    item-text="name"
                    item-value="name"
                    label="Clearing Institutes"
                    @change="getReport(); loading = true;"
                    @click:clear="clearMerchant()"
                ></v-select>
            </v-col>

            <!-- From Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                        :max="maxdate"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                        :max="maxdate"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col align="end" class="py-2">
                <v-btn
                    small
                    dark
                    color="primary"
                    class="mb-3"
                    @click="download"
                    ><v-icon>mdi-arrow-down-bold</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="15"
                    hide-default-footer
                    class="elevation-0"
                    dense
                >
                    <template v-slot:item.date>
                        {{ fromDate }} - {{ toDate }}
                    </template>
                    <template v-slot:item.debit="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.debit) }}
                    </template>
                    <template v-slot:item.volume="{ item }">
                        {{ new Intl.NumberFormat('en-US').format(item.volume) }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
    data() {
        return {
            acquirer: null,
            clearingInstituteOptions: [],
            fromDateModal: null,
            toDateModal: null,
            fromDate: moment().startOf('month').format('YYYY-MM-DD'),
            toDate: moment().subtract('1', 'day').format('YYYY-MM-DD'),
            loading: true,
            report: null,
            headers: [{ text: 'Date', value: 'date', sortable: false },
                      { text: 'Acquirer', value: 'clearingInstitute', sortable: false },
                      { text: 'Total Debit', value: 'debit', sortable: true, align: "center" },
                      { text: 'Total Volume', value: 'volume', sortable: true, align: "center" }]
        }
    },
    beforeMount() {
        this.getClearingInstitutes();
        this.getReport();
    },
    methods: {
        getClearingInstitutes() {
            axios({
            method: 'get',
            url: 'get-clearing-institutes-live',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.clearingInstituteOptions = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getReport() {
            axios({
            method: 'post',
            url: `acquirer-processing`,
            data: { acquirer: this.acquirer,
                    fromDate: this.fromDate,
                    toDate: this.toDate },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        clear() {
            console.log(this.acquirer);
        },
        handleDateFilters() {
            if(this.toDate < this.fromDate) {
                this.fromDate = this.toDate;
            }
            this.getReport();
        },
        download() {
            axios({
                method: 'post',
                url: 'download-acquirer-processing',  
                data: { acquirer: this.acquirer,
                        fromDate: this.fromDate,
                        toDate: this.toDate },            
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'acquirer-processing-report.csv');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>

</style>